import config from "@Config/index";
import axios from "axios";
import urlJoin from "helpers/urljoin";

const getReferrerDetails = async (referCode: string) => {
  const url = urlJoin(config.API_URL, "api/v0/users/referrer_details");

  try {
    const res: any = await axios.get(url, {
      params: {
        refer_code: referCode,
      },
    });

    if (res.data?.data?.name) {
      return { name: res.data.data.name };
    }

    return { name: "" };
  } catch (error) {
    console.error("Error fetching referrer details:", error);
    return { name: "" }; // Return default value in case of an error
  }
};

export default getReferrerDetails;
